import { useConfirmationDialog } from '@factorialco/deprecated-design-system'
import {
  PerformanceGoalsDeleteMetricGroupDocument,
  PerformanceGoalsDeleteMetricGroupMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

type GoalsMetricGroup = NonNullable<
  PerformanceGoalsDeleteMetricGroupMutation['goalsMutations']['deleteGoalsMetricGroup']['metricGroup']
>

export const useDeleteMetricGoal = () => {
  const [deleteMetric] = useMutation(PerformanceGoalsDeleteMetricGroupDocument, {
    extractorFn: (deletionData) => deletionData?.goalsMutations?.deleteGoalsMetricGroup,
  })

  const { openDialog } = useConfirmationDialog()

  const handleDelete = (
    metric: Pick<GoalsMetricGroup, '__typename' | 'id'>,
    onComplete?: () => void
  ) => {
    openDialog({
      title: i18n.t('performance_goals.delete_goal_dialog.title'),
      confirmLabel: i18n.t('performance_goals.delete_goal_dialog.delete_button'),
      description: i18n.t('performance_goals.delete_goal_dialog.description'),
      onConfirm: async () => {
        const response = await deleteMetric({
          variables: { id: metric.id },
          update(cache) {
            cache.evict({
              id: cache.identify({ id: metric.id, __typename: metric.__typename }),
            })
          },
        })

        const result = handleResult(response, () => null)
        if (result.success) {
          app.setFlash({
            type: 'correct',
            message: i18n.t('common.removed_successfully'),
          })
          onComplete?.()
        }
      },
    })
  }

  return {
    handleDelete,
  }
}
